import React, { useEffect, useRef, useState } from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { getShopifyImage } from "gatsby-source-shopify"

import ImageThumb from "./ImageThumb"
import ViewProductModal from "@components/modal/ViewProductModal"
//import HeartIcon from "@components/common/HeartIcon"
//import SoftButton from "@components/common/SoftButton"
import UseWindowSize from "@components/helpers/UseWindowSize"
import { MagnifyingGlassPlus } from "@phosphor-icons/react"
import { Navigation } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"
import { Scrollbar } from "swiper/modules"
//import SliderButton from "@images/icons/slider-button.svg"


const ProductImages = ({images}) => {

    const [productImages, setProductImages] = useState([]);
    const [thumbImages, setThumbImages] = useState([]);

    const [thumbSelected, setThumbSelected] = useState(0)
    const [useMobilePosition, setUseMobilePosition] = useState(false)
    const [modalOpen, setModalOpen] = useState(false)
    const { width } = UseWindowSize()
    const [bigImage, setBigImage] = useState(null)
    const [swiperPosition, setSwiperPosition] = useState('start')

    useEffect(() => {
        setUseMobilePosition(width > 768 ? false : true)
    }, [width])

    const navigationPrevRef = useRef(null)
    const navigationNextRef = useRef(null)

    useEffect(() => {
        if (images && images.length > 0) {
            // Map over images and store them in productImages
            const imageUrls = images?.reduce((accum, obj, index, src) => {
                const gatsbyImage = {
                    gatsbyImageData: obj?.preview?.image?.gatsbyImageData,
                    src: obj?.preview?.image?.src,
                    //isVideo: index === images.length - 1 ? true : false, // this assumes that the video is last on the list
                }

                
                return [...accum, gatsbyImage]
            }, []);

            
            const thumbUrls = images.reduce((accum, obj, index, src) => {
                const imageData = {
                  originalSrc: obj?.preview?.image?.src,
                  width: obj?.preview?.image?.gatsbyImageData?.width,
                  height: obj?.preview?.image?.gatsbyImageData?.height,
                };
              
                const gatsbyImage = {
                  gatsbyImageData: getShopifyImage({
                    image: imageData ?? imageData,
                    layout: "constrained",
                    crop: "contain",
                    width: 84,
                    height: 127,
                  }),
                  src: imageData.originalSrc,
                };

                
                return [...accum, gatsbyImage]
            }, []);

            setThumbImages(thumbUrls);
            setProductImages(imageUrls);
        }
    }, [images]);


    useEffect(() => {
        const imageData = {
            originalSrc: productImages?.[thumbSelected]?.src,
            width: productImages?.[thumbSelected]?.gatsbyImageData?.width,
            height: productImages?.[thumbSelected]?.gatsbyImageData?.height,
        };

        if(imageData.originalSrc !== undefined) {
            setBigImage(getShopifyImage({
                image: imageData ?? imageData,
                layout: "constrained",
                crop: "contain",
                width: 532,
                height: 798,
            }));
        }
    }, [thumbSelected, productImages]);
    
    return (
        <React.Fragment>
            {/*width <= 800 && (
                <section className="w-full flex justify-between px-4">
                    <>
                        <section className="flex flex-nowrap gap-x-2">
                            <HeartIcon size={20} onClick={() => {}} />
                            <SoftButton label={"ADD TO WISHLIST"} onClick={() => {}} />
                        </section>
                    </>
                </section>
            )*/}

            <div className="bg-white flex flex-wrap lg:flex-nowrap flex-col-reverse lg:flex-row gap-3 pb-4">
                <div className="relative h-min lg:h-[740px] xl:h-[798px] w-full lg:w-fit overflow-hidden">
                    <div className={`absolute h-64 w-full bg-gradient-to-b from-white via-transparent to-transparent top-0 z-40 pointer-events-none ${swiperPosition === 'start' ? 'hidden' : 'hidden lg:block'}`} />
                    <div className={`absolute h-64 w-full bg-gradient-to-t from-white via-transparent to-transparent bottom-0 z-40 pointer-events-none ${swiperPosition === 'end' ? 'hidden' : 'hidden lg:block'}`} />
                    <Swiper
                        modules={[Scrollbar, Navigation]}
                        scrollbar={{ draggable: true, hide: true }}
                        direction={`${width >= 1024 ? 'vertical' : 'horizontal' }`}
                        onReachBeginning={() => setSwiperPosition('start')}
                        onReachEnd={() => setSwiperPosition('end')}
                        onSliderMove={() => {
                            const scrollbar = document.querySelector('.swiper-scrollbar');
                            if (scrollbar) scrollbar.classList.add('active');
                        }}
                        onTouchEnd={() => {
                            const scrollbar = document.querySelector('.swiper-scrollbar');
                            if (scrollbar) setTimeout(() => scrollbar.classList.remove('active'), 500);
                        }}
                        // onBeforeSlideChangeStart={() => setSwiperPosition('mid')}
                        spaceBetween={5}
                        slidesPerView={6}
                        breakpoints={{300: {
                            slidesPerView: 4.5,
                            spaceBetween: 5,
                        },
                        768: {
                            slidesPerView: 7.5,
                        },
                        900: {
                            slidesPerView: 7.5,
                        },
                        1024: {
                            slidesPerView: 5,
                        },
                        1280: {
                            slidesPerView: 6,
                        },}}
                        navigation={false}
                        onBeforeInit={(swiper) => {
                            swiper.params.navigation.prevEl = navigationPrevRef.current;
                            swiper.params.navigation.nextEl = navigationNextRef.current;
                        }}
                        className="max-h-[670px] xl:max-h-[798px] h-full"
                        // style={{height: '100%', maxHeight: '798px'}}
                    >
                        {
                            thumbImages && thumbImages.map((item, index) => {
                                return (
                                    <SwiperSlide key={`${item?.id}-${index}`}>
                                        <ImageThumb
                                            key={index}
                                            image={item?.gatsbyImageData}
                                            index={index}
                                            selected={thumbSelected}
                                            onClick={() => setThumbSelected(index)}
                                            isVideoThumbnail={index === 0 ? false : false}
                                            maxHeight="max-h-none"
                                        />
                                    </SwiperSlide>
                                );
                            })
                        }
                    </Swiper>
                </div>
            

                {/* <div className="flex flex-nowrap lg:flex-wrap items-start max-w-full lg:max-w-21 max-h-[798px] gap-2 md:gap-3 overflow-x-scroll lg:overflow-y-scroll px-2 lg:px-0 scrollbar-hide">
                    {
                        thumbImages && thumbImages.slice(0, 6).map((thumb, key) => (
                            <ImageThumb
                                key={key}
                                image={thumb?.gatsbyImageData}
                                index={key}
                                selected={thumbSelected}
                                onClick={() => setThumbSelected(key)}
                            />
                        ))
                    }
                </div> */}

                <div
                    className="relative flex flex-1 overflow-hidden max-w-full cursor-pointer"
                    // className="relative flex flex-1 overflow-hidden max-w-full lg:max-w-[532px] max-h-110 md:max-h-[800px] cursor-pointer"
                    onClick={() => setModalOpen(!modalOpen)}
                >
                    {
                        /*productImages?.[thumbSelected]?.isVideo ? 
                        <>
                            <video className="mx-auto" aria-label={'my-video'} preload="none" playsInline="playsinline" controls="controls" autoPlay="autoplay" muted="muted">
                                <source 
                                    src="https://blackboughswim.com/cdn/shop/videos/c/vp/463ef402350f400f98d26be8d9dd9e40/463ef402350f400f98d26be8d9dd9e40.HD-720p-2.1Mbps-35695865.mp4?v=0"
                                    type="video/mp4" 
                                />
                                Your browser does not support the video tag.
                            </video>
                        </>
                        : */ productImages?.[thumbSelected]?.gatsbyImageData &&
                        
                            
                            bigImage ? 
                                <>
                                    <GatsbyImage
                                        className="w-full lg:w-auto h-full object-contain"
                                        objectFit="contain"
                                        objectPosition={'top'}
                                        loading="lazy"
                                        alt="prodImg"
                                        image={bigImage ?? bigImage}
                                    />
                                    <MagnifyingGlassPlus
                                        className={`absolute icon-round-bg soft-inactive p-2 m-4 ${
                                            useMobilePosition && "bottom-0"
                                        }`}
                                        size={56}
                                        weight="light"
                                    />
                                </> : null
                            
                    }
                </div>
            </div>

            <ViewProductModal
                isOpen={modalOpen}
                defaultImage={productImages[thumbSelected]?.src}
                selected={thumbSelected}
                thumbs={thumbImages}
                productImages={productImages}
                onClose={() => setModalOpen(false)}
            />
        </React.Fragment>
    );
}

export default ProductImages